import React from 'react';
import RecipeListItem from './RecipeListItem';
import { ErrorHandler } from '../ErrorHandler';
import { useTranslation } from 'react-i18next';
import { Recipe } from '../../services/recipeTypes';

type RecipesListProps = {
    items?: Recipe[];
    isLoaded?: boolean;
};

const RecipesList = ({ items = [], isLoaded = true }: RecipesListProps) => {
    const { i18n } = useTranslation();

    if (!isLoaded) {
        return null;
    }

    return (
        items.length ?
            <ul className="recipe__list">
                {items.map((it) => (
                    <li key={`${it.id}`} className="recipe__list-item">
                        <RecipeListItem recipeId={it.id} recipe={it} />
                    </li>
                ))}
            </ul>
            :
            <ErrorHandler titleValue={i18n.t('app.page.profile.emptyData')} />
    );
};

export default RecipesList;
